import { STATS } from "../../data";
import { Reveal } from "./Reveal";

const STAT_COLORS = ["", "#4d9fe8", "#4dd6a5", "#b98bff"];

export const Stats = () => (
  <section data-testid="stats-section" className="relative py-20 md:py-28 border-y border-[#bf953f]/10 bg-[#0a192f] overflow-hidden">
    <div className="absolute -top-1/2 left-1/4 h-[50vh] w-[50vh] rounded-full bg-[#1a4b9b]/12 blur-[150px] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.08}>
          <div data-testid={`stat-${i}`} className="text-center lg:text-left">
            <p
              className={`font-serif-display text-5xl md:text-7xl font-medium leading-none ${STAT_COLORS[i] ? "" : "text-gold-gradient"}`}
              style={STAT_COLORS[i] ? { color: STAT_COLORS[i] } : undefined}
            >
              {s.value}
            </p>
            <p className="mt-3 font-body text-xs md:text-sm tracking-[0.15em] uppercase text-white/50">
              {s.label}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
